/**
 * AI.GEN lines=1-80
 * 调度工作台 localStorage 工具函数
 */
import dayjs from 'dayjs';

import { OrderBusinessType } from '@/components/enum';

/**
 * AI.GEN lines=1-5
 * 计算默认日期范围：T-2 0:00:00 到 T+2 0:00:00
 * 如今天是1月20日，返回1月18日0点到1月22日0点
 */
export const getDefaultDateRange = (): [dayjs.Dayjs, dayjs.Dayjs] => {
  const today = dayjs();
  const startDate = today.subtract(2, 'day').startOf('day');
  const endDate = today.add(2, 'day').startOf('day');
  return [startDate, endDate];
};

/**
 * AI.GEN lines=1-5
 * 从 localStorage 读取上一次选择的城市
 */
export const getInitialCity = (): string | undefined => {
  try {
    const stored = localStorage.getItem('dispatchWorkbenchCity');
    return stored || undefined;
  } catch {
    return undefined;
  }
};

/**
 * AI.GEN lines=1-10
 * 从 localStorage 读取缓存的日期范围
 * 如果有缓存则使用缓存，否则使用默认值（今天0:00:00到23:59:59）
 */
export const getInitialDateRange = (): [dayjs.Dayjs, dayjs.Dayjs] => {
  try {
    const stored = localStorage.getItem('dispatchWorkbenchDateRange');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length === 2) {
        const startDate = dayjs(parsed[0]);
        const endDate = dayjs(parsed[1]);
        if (startDate.isValid() && endDate.isValid()) {
          return [startDate, endDate];
        }
      }
    }
  } catch {
    // 解析失败时使用默认值
  }
  return getDefaultDateRange();
};

/**
 * AI.GEN lines=1-5
 * 从 localStorage 读取订单业务类型
 */
export const getInitialOrderBusinessType = (): OrderBusinessType[] => {
  try {
    const stored = localStorage.getItem('orderBusinessType');
    if (stored) {
      return stored.split(',').map(Number) as OrderBusinessType[];
    }
  } catch {
    // 解析失败时使用默认值
  }
  return [OrderBusinessType.HP];
};

/**
 * AI.GEN lines=1-5
 * 从 localStorage 读取配送标签列表
 */
export const getInitialDeliveryTagList = (): string[] => {
  try {
    const stored = localStorage.getItem('deliveryTagList');
    if (stored) {
      return stored.split(',').filter(Boolean);
    }
  } catch {
    // 解析失败时使用默认值
  }
  return [];
};

/**
 * AI.GEN lines=1-5
 * 从 localStorage 读取缩放值
 */
export const getInitialZoom = (): number => {
  try {
    const stored = localStorage.getItem('dispatchZoom');
    if (stored) {
      const parsed = Number.parseInt(stored, 10);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }
  } catch {
    // 解析失败时使用默认值
  }
  return 100;
};

/**
 * AI.GEN lines=1-5
 * 从 localStorage 读取时间类型
 */
export const getInitialTimeType = (): 0 | 1 => {
  try {
    const stored = localStorage.getItem('dispatchTimeType');
    if (stored !== null) {
      const parsed = Number.parseInt(stored, 10);
      if (parsed === 0 || parsed === 1) {
        return parsed as 0 | 1;
      }
    }
  } catch {
    // 解析失败时使用默认值
  }
  return 1;
};

/**
 * AI.GEN lines=1-5
 * 从 localStorage 读取是否填写撤销理由
 */
export const getInitialIsFillReason = (): boolean => {
  try {
    const stored = localStorage.getItem('dispatchIsFillReason');
    if (stored !== null) {
      return stored === 'true';
    }
  } catch {
    // 解析失败时使用默认值
  }
  return false;
};

/**
 * AI.GEN lines=1-5
 * 从 localStorage 读取PF站点ID
 */
export const getInitialSiteId = (): number | undefined => {
  try {
    const stored = localStorage.getItem('siteId');
    if (stored) {
      return Number.parseInt(stored, 10);
    }
  } catch {
    // 解析失败时使用默认值
  }
  return undefined;
};
